<template>
  <div class="signinSheetContainer">
    <div class="container">
      <div class="maxWidth">
        <div class="signinSheetBox">
          <div class="sheetList">
            <ul>
              <li v-for="(item, index) in dataSheetItem" :key="index">
                <div class="item sheetItem">
                  <div class="num">{{ item.label }}</div>
                  <div class="img">
                    <img :src="require(`@/website/${DEF_webStyle}/images/signinSheet/coin.svg`)
                " class="img-fluid" />
                  </div>
                  <div class="name">+{{ item.amount }}</div>
                  <div class="stampBox">
                    <div class="stampImg">
                      <img :src="require(`@/website/${DEF_webStyle}/images/signinSheet/stamp.svg`)
                " class="img-fluid" />
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <button class="sheetBtn" @click="start">{{ $t("store.event.sign") }}</button>
    </div>
    <Overlay v-model="isLoading" />

    <!-- 登入顯示 -->
    <b-modal id="checkLogin" modal-class="modalSigninResult" centered>
      <template #default>
        <div class="signinItem">
          <div class="title text-center">{{ $t("store.event.login") }}</div>
        </div>
      </template>
      <template #modal-footer>
        <b-button class="closeBtn" block @click="login">{{ $t("store.confirm") }}</b-button>
      </template>
    </b-modal>

    <!-- 錯誤提示 -->
    <b-modal id="message" modal-class="modalSigninResult modalHint" centered>
      <template #modal-header>
        <div class="title text-center">{{ errorMsg }}</div>
      </template>
      <template #modal-footer>
        <b-button class="closeBtn" block @click="handleError">OK</b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import Overlay from "@/components/common/overlay.vue";
export default {
  components: {
    Overlay
  },
  props: {
    sheetId: {
      type: Number,
      require: true,
    },
  },
  data() {
    return {
      IsSubmit: false,
    };
  },
  methods: {
    start() {
      if (this.IsSubmit)
        return;

      this.IsSubmit = true;
      this.signin(this.sheetId).then(() => {
        this.itemStamped();
        this.IsSubmit = false;
      });
    },
    inspection() {
      if (this.$auth.$state.loggedIn) {
        this.errorCode && this.errorCode.message ? this.$bvModal.show("message") : this.isItemStamped();
      } else {
        this.$bvModal.show("checkLogin");
      }
    },
    login() {
      this.$router.push({ name: "account-login", parames: null, query: null });
    },
    handleError() {
      const redirectErrors = [
        'EventPeriodNotStartedOrHasEnded',
        'iinvalid_discount_setting',
        '查無資料',
        '資格不符'
      ]
      if (redirectErrors.includes(this.errorCode.message)) {
        this.$router.replace({ path: "/" });
        return;
      }
      this.$bvModal.hide("message");
    },
    itemStamped() {
      if (this.errorCode.message) {
        this.$bvModal.show("message");
        return;
      }
      let stampItem = document.querySelectorAll(".sheetItem:not(.stamped)")[0];
      let itemTop = stampItem.offsetTop;
      let headerH;

      if (document.querySelectorAll(".desktop")[0]) {
        headerH =
          document.querySelectorAll(".idex-wrap>header")[0].offsetHeight;
      } else if (document.querySelectorAll(".mobile")[0]) {
        headerH = document.querySelectorAll(".idx-header")[0].offsetHeight;
      }

      let scrollH = itemTop - headerH - 20;
      window.scrollTo({ top: scrollH, behavior: "smooth" });

      if (stampItem) {
        stampItem.classList.add("stamped");
      }
    },
    isItemStamped() {
      if (this.$auth.$state.loggedIn === false) {
        return;
      }
      let isStampitem = document.querySelectorAll(".sheetItem");

      isStampitem.forEach((item, index) => {
        if (index < this.signinCount) {
          item.classList.add("stamped");
        }
      });
    },
    ...mapActions("signinSheet", ["getDataSheet", "signin", "getSigninCount"]),
  },
  mounted() {
    this.$nextTick(async () => {
      await this.getDataSheet(this.sheetId);
      await this.getSigninCount(this.sheetId);
      this.inspection();
    })
  },
  computed: {
    DEF_webStyle() {
      return process.env.DEF_webStyle || "default";
    },
    errorMsg() {
      const errorMsgs = {
        'EventPeriodNotStartedOrHasEnded': 'store.event.event_period_not_started_or_hasended',
        'NoCorrespondingFlag': 'store.event.no_corresponding_flag',
        'NotInAccountGroup': 'store.event.not_in_accountGroup',
        'InvalidDiscountSetting': 'store.event.iinvalid_discount_setting',
        'EmptyCheckInItems': 'store.event.empty_slices',
        'OutOfQualification': 'store.event.out_of_qualification',
        'CheckedInToday': 'store.event.checked_finish',
        'CheckInFinished': 'store.event.checked_over',
        '查無資料': 'store.event.no_data',
        '資格不符': 'store.event.qualifiy'
      };
      return this.$t(errorMsgs[this.errorCode.message]);
    },
    isLoading() {
      return this.loading;
    },
    ...mapState("signinSheet", ["dataSheet", "dataSheetItem", "haveSignQualify", "errorCode", "loading", "signinCount", "signStatus"])
  },
};
</script>
